<template>
  <b-row>
    <b-col
      cols="12"
    >
      <form-wizard
        ref="refWizard"
        color="#fdb813"
        :title="null"
        :subtitle="null"
        next-button-text="Volgende"
        back-button-text="Terug"
        finish-button-text="Offerte aanvragen"
        layout="vertical"
        class="wizard-vertical mb-3"
        @on-complete="formSubmitted"
        @on-change="scrollToTop"
      >

        <tab-content
          title="Motorrijtuigenverzekering"
          icon="feather icon-file-text"
          :before-change="validationInsuranceTypeForm"
        >
          <validation-observer
            ref="insuranceType"
            tag="form"
          >
            <b-row>
              <b-col
                cols="8"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Motorrijtuigenverzekering
                </h5>
                <small>
                  Bereken hier je premie.
                </small>
              </b-col>
              <b-col
                cols="4"
                class="mb-2"
                style="text-align: right"
              >
                <b-badge
                  variant="primary"
                  style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                  @click="resetForm"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    size="18"
                  />
                </b-badge>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="category"
                  rules="required"
                >
                  <b-form-group
                    label="Kies je type voertuig"
                    label-for="category"
                  >
                    <VueRadioButton
                      v-model="calculation.category"
                      :options="categoryButtons"
                    >
                      <template #label="{ props }">
                        <img
                          :src="props.icon"
                          width="50"
                          height="50"
                        >
                        <span>{{ props.title }}</span>
                      </template>
                    </VueRadioButton>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="calculation.category === 'PRIVATE'"
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="class"
                  rules="required"
                >
                  <b-form-group
                    label="Gebruiksvorm"
                    label-for="class"
                  >
                    <VueRadioButton
                      v-model="calculation.class"
                      :options="classButtons"
                    >
                      <template #label="{ props }">
                        <img
                          :src="props.icon"
                          :width="props.size"
                          :height="props.size"
                        >
                        <span>{{ props.title }}</span>
                      </template>
                    </VueRadioButton>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="calculation.category === 'PRIVATE' || calculation.category === 'TAXI' || calculation.category === 'RENTAL' || calculation.category === 'LESSON'"
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="weight"
                  rules="required"
                >
                  <b-form-group
                    label="Gewicht (kg)"
                    label-for="weight"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      v-model="calculation.weight"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="weightOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="active"
                      label="name"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <!--                </validation-provider>-->
              </b-col>
              <b-col
                v-if="calculation.category === 'BUS'"
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="persons"
                  rules="required"
                >
                  <b-form-group
                    label="Aantal zitplaatsen"
                    label-for="persons"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      v-model="calculation.persons"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="personsOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="active"
                      label="name"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="calculation.category === 'FREIGHT1' || calculation.category === 'FREIGHT2'"
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="payload"
                  rules="required"
                >
                  <b-form-group
                    label="Laadvermogen (kg)"
                    label-for="payload"
                    :state="getValidationState(validationContext)"
                  >
                    <v-select
                      v-model="calculation.payload"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="payloadOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="active"
                      label="name"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>

        <tab-content
          title="Gegevens"
          icon="feather icon-user"
          :before-change="validationInformationForm"
        >
          <validation-observer
            ref="information"
            tag="form"
          >
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
                style="text-align: right"
              >
                <b-badge
                  variant="primary"
                  style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                  @click="resetForm"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    size="18"
                  />
                </b-badge>
              </b-col>
              <b-col
                v-if="calculation.category !== 'MOPED'"
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="insuredAmount"
                  rules="required"
                >
                  <b-form-group
                    label="Kies de gewenste dekking"
                    label-for="insuredAmount"
                  >
                    <VueRadioButton
                      v-model="calculation.insuredAmount"
                      :options="insuredAmountButtons"
                    >
                      <template #label="{ props }">
                        <img
                          :src="props.icon"
                          width="50"
                          height="50"
                        >
                        <span>{{ props.title }}</span>
                      </template>
                    </VueRadioButton>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-else
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="insuredAmount"
                  rules="required"
                >
                  <b-form-group
                    label="Dekking"
                    label-for="insuredAmount"
                  >
                    <VueRadioButton
                      v-model="calculation.insuredAmount"
                      :options="insuredAmountMopedButtons"
                    >
                      <template #label="{ props }">
                        <img
                          :src="props.icon"
                          width="50"
                          height="50"
                        >
                        <span>{{ props.title }}</span>
                      </template>
                    </VueRadioButton>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="constructionYear"
                  rules="required|integer"
                >
                  <b-form-group
                    label="Bouwjaar"
                    label-for="payload"
                  >
                    <b-form-input
                      id="constructionYear"
                      v-model="calculation.constructionYear"
                      type="number"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="calculation.miniAvailable"
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="miniInsuredAmount"
                  rules=""
                >
                  <b-form-group
                    label="Mini kasko dekking"
                    label-for="miniInsuredAmount"
                  >
                    <b-alert
                      variant="primary"
                      :show="true"
                      class="mb-1"
                    >
                      <div class="alert-body">
                        <feather-icon
                          icon="InfoIcon"
                          class="mr-50"
                        />
                        Kies één van de volgende dekkingen, indien u naast de MSR aanvullend een Mini Casco verzekering wenst af te sluiten.
                      </div>
                    </b-alert>
                    <VueRadioButton
                      v-model="calculation.miniInsuredAmount"
                      :options="miniCascoButtons"
                    >
                      <template #label="{ props }">
                        <img
                          :src="props.icon"
                          width="50"
                          height="50"
                        >
                        <span>{{ props.title }}</span>
                      </template>
                    </VueRadioButton>
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="includeLegalInsurance"
                  rules=""
                >
                  <b-form-group
                    :state="getValidationState(validationContext)"
                  >
                    <b-form-checkbox
                      v-model="calculation.includeLegalInsurance"
                      name="includeLegalInsurance"
                      :state="getValidationState(validationContext)"
                      :value="true"
                      :unchecked-value="false"
                      required
                    >
                      Ik wil rechtsbijstand
                    </b-form-checkbox>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                v-if="calculation.category !== 'BUS'"
                cols="12"
                md="12"
              >
                <validation-provider
                  #default="validationContext"
                  name="includeOccupantsInsurance"
                  rules=""
                >
                  <b-form-group
                    :state="getValidationState(validationContext)"
                  >
                    <b-form-checkbox
                      v-model="calculation.includeOccupantsInsurance"
                      name="includeOccupantsInsurance"
                      :state="getValidationState(validationContext)"
                      :value="true"
                      :unchecked-value="false"
                      required
                    >
                      Ik wil ongevallen inzittenden verzekering
                    </b-form-checkbox>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>

        <tab-content
          title="Premie"
          icon="feather icon-link"
        >
          <b-row>
            <b-col
              cols="8"
              class="mb-2"
            >
              <h5 class="mb-0">
                De premie is
              </h5>
              <!--              <small>De premie is indicatief. Bij het ontvangen van het ingevuld medisch vragenformulier kunnen kortingen en/of toeslagen worden gegeven. ook zijn er nig een aantal kosten die niet toegevoegd zijn aan de berekende premie.</small>-->
            </b-col>
            <b-col
              cols="4"
              class="mb-2"
              style="text-align: right"
            >
              <b-badge
                variant="primary"
                style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                @click="resetForm"
              >
                <feather-icon
                  icon="RefreshCcwIcon"
                  size="18"
                />
              </b-badge>
            </b-col>
            <b-col
              cols="12"
              md="12"
            >
              <b-card
                no-body
                class="card-apply-job"
              >
                <div
                  class="apply-job-package bg-light-primary rounded"
                  style="border-bottom-right-radius:0 !important;border-bottom-left-radius:0 !important;"
                >
                  <div>
                    <sup class="text-body">
                      <small>SRD</small>
                    </sup>
                    <h2 class="d-inline mr-25">
                      {{ calculation.premium }}
                    </h2>
                    <!--                    <sub class="text-body"><small>/ month</small></sub>-->
                  </div>
                  <!--                  <b-badge-->
                  <!--                    variant="light-primary"-->
                  <!--                    pill-->
                  <!--                  >-->
                  <!--                    indicatie-->
                  <!--                  </b-badge>-->
                </div>
                <b-card-body>
                  <b-card-text class=" ml-0 mr-0 pl-0 pr-0 mb-2">
                    <p style="padding: 10px">
                      Deelnemen aan het verkeer betekent dat u altijd alert moet zijn, want een ongeluk zit in een klein
                      hoekje. Toch kan het voorkomen dat u of een medeweggebruiker de veroorzaker bent/is van een
                      ongeluk. Dit kan (hoge) financiële kosten voor bijvoorbeeld het herstellen van de schade met zich
                      meebrengen. Met de MSR, komt Self Reliance u op een degelijke manier tegemoet en geven wij een
                      dekking aan zowel de veroorzaker alsook de benadeelde.
                    </p>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </tab-content>

        <tab-content
          title="Offerte"
          icon="feather icon-map-pin"
        >
          <validation-observer
            ref="offer"
            tag="form"
          >
            <b-row>
              <b-col
                cols="8"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Adres
                </h5>
              </b-col>
              <b-col
                cols="4"
                class="mb-2"
                style="text-align: right"
              >
                <b-badge
                  variant="primary"
                  style="border-radius: 0.5rem !important;padding: 0.5rem 0.5rem;"
                  @click="resetForm"
                >
                  <feather-icon
                    icon="RefreshCcwIcon"
                    size="18"
                  />
                </b-badge>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="firstName"
                  rules="required"
                >
                  <b-form-group
                    label="Voornaam"
                    label-for="firstName"
                  >
                    <b-form-input
                      id="firstName"
                      v-model="calculation.firstName"
                      :state="getValidationState(validationContext)"
                      trim
                      type="text"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="lastName"
                  rules="required"
                >
                  <b-form-group
                    label="Achternaam"
                    label-for="lastName"
                  >
                    <b-form-input
                      id="lastname"
                      v-model="calculation.lastName"
                      :state="getValidationState(validationContext)"
                      trim
                      type="text"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="phone"
                  rules="required|integer|min:6"
                >
                  <b-form-group
                    label="Telefoonnummer"
                    label-for="phone"
                  >
                    <b-form-input
                      id="phone"
                      v-model="calculation.phoneNumber"
                      type="text"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <validation-provider
                  #default="validationContext"
                  name="email"
                  rules="required|email"
                >
                  <b-form-group
                    label="E-mailadres"
                    label-for="email"
                  >
                    <b-form-input
                      id="email"
                      v-model="calculation.email"
                      type="email"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </tab-content>
      </form-wizard>
    </b-col>
  </b-row>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import store from '@/store'
import { onUnmounted } from '@vue/composition-api'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BAlert, BBadge,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BRow,
} from 'bootstrap-vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import VueRadioButton from '@/views/components/VueRadioButton.vue'
import { countryList, districtsList, surinameCityList } from '@core/utils/list'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import wamStoreModule from '@/views/pages/wam/wamStoreModule'
import { formatPrice } from '@core/utils/utils'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInvalidFeedback,
    BFormInput,
    BCard,
    BFormCheckbox,
    VueRadioButton,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BAlert,
    BCardText,
    BCardBody,
    BBadge,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      calculation: {
        premium: null,
        miniAvailable: false,
        constructionYear: null,
        category: null,
        weight: null,
        persons: null,
        payload: null,
        insuredAmount: null,
        miniInsuredAmount: null,
        includeLegalInsurance: false,
        includeOccupantsInsurance: false,
        class: null,
        emailText: null,
      },
      blankCalculation: {
        premium: null,
        miniAvailable: false,
        constructionYear: null,
        category: null,
        weight: null,
        persons: null,
        payload: null,
        insuredAmount: null,
        miniInsuredAmount: null,
        includeLegalInsurance: false,
        includeOccupantsInsurance: false,
        class: null,
        emailText: null,
      },
      birthDateConfig: {
        maxDate: 'today',
        altFormat: 'd-m-Y',
        dateFormat: 'Y-m-d',
        altInput: true,
        allowInput: true,
      },
      categoryButtons: [
        {
          id: 'PRIVATE',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/car.png'),
          title: 'Personenauto',
          key: 'category',
        },
        {
          id: 'FREIGHT2',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/truck.png'),
          title: 'Vracht',
          key: 'category',
        },
        {
          id: 'BUS',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/bus.png'),
          title: 'Bus',
          key: 'category',
        },
        {
          id: 'MOTORCYCLE',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/motor.png'),
          title: 'Motorfiets',
          key: 'category',
        },
        {
          id: 'MOPED',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/brom.png'),
          title: 'Bromfiets',
          key: 'category',
        },
        {
          id: 'TRACTOR',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/tractor.png'),
          title: 'Tractor',
          key: 'category',
        },
        {
          id: 'TRACTOR_LP',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/tractor.png'),
          title: 'Landbouw',
          key: 'category',
        },
      ],
      classButtons: [
        {
          id: 'PRIVATE',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/car2.svg'),
          title: 'Prive',
          key: 'gebruiksvorm',
          size: 40,
        },
        {
          id: 'TAXI',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/taxi.svg'),
          title: 'Taxi',
          key: 'gebruiksvorm',
          size: 40,
        },
        {
          id: 'RENTAL',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/garage-car.svg'),
          title: 'Autoverhuur',
          key: 'gebruiksvorm',
          size: 50,
        },
        {
          id: 'LESSON',
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/screen-users.svg'),
          title: 'lesauto',
          key: 'gebruiksvorm',
          size: 50,
        },
      ],
      insuredAmountMopedButtons: [
        {
          id: 47000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 47.000',
          key: 'insuredAmountMOPED',
        },
        {
          id: 52000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 52.000',
          key: 'insuredAmountMOPED',
        },
        {
          id: 60000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 60.000',
          key: 'insuredAmountMOPED',
        },
        {
          id: 70000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 70.000',
          key: 'insuredAmountMOPED',
        },
        {
          id: 80000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 80.000',
          key: 'insuredAmountMOPED',
        },
      ],
      miniCascoButtons: [
        {
          id: 20000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 20.000',
          key: 'miniInsuredAmount',
        },
        {
          id: 30000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 30.000',
          key: 'miniInsuredAmount',
        },
      ],
      isFirstTime: true,
      weightOptions: [
        { value: 'P1', name: '0 T/M 800 KG' },
        { value: 'P2', name: '801 T/M 1200 KG' },
        { value: 'P3', name: '1201 T/M 1600 KG' },
        { value: 'P4', name: '1601 T/M 2000 KG' },
        { value: 'P5', name: '2001 KG en meer' },
      ],
      personsOptions: [
        { value: 'B1', name: '11 T/M 20 zitplaatsen' },
        { value: 'B2', name: '21 T/M 30 zitplaatsen' },
        { value: 'B3', name: '31 zitplaatsen en meer' },
      ],
      payloadOptions: [
        { value: 'V1', name: '0 T/M 1000 KG' },
        { value: 'V2', name: '1001 T/M 2000 KG' },
        { value: 'V3', name: '2001 T/M 3000 KG' },
        { value: 'V4', name: '3001 T/M 4000 KG' },
        { value: 'V5', name: '4001 T/M 5000 KG' },
        { value: 'V6', name: '5001 KG en meer' },
      ],
    }
  },
  computed: {
    insuredAmountButtons() {
      if (this.calculation.category === 'MOTORCYCLE') {
        return [
          {
            id: 175000,
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/money-bill-1.svg'),
            title: 'SRD 175.000',
            key: 'insuredAmount',
          },
          {
            id: 190000,
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/money-bill-1.svg'),
            title: 'SRD 190.000',
            key: 'insuredAmount',
          },
          {
            id: 220000,
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/money-bill-1.svg'),
            title: 'SRD 100.000',
            key: 'insuredAmount',
          },
          {
            id: 250000,
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/money-bill-1.svg'),
            title: 'SRD 125.000',
            key: 'insuredAmount',
          },
          {
            id: 300000,
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/money-bill-1.svg'),
            title: 'SRD 150.000',
            key: 'insuredAmount',
          },
        ]
      }
      if (this.calculation.category === 'TRACTOR_LP') {
        return [
          {
            id: 175000,
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/money-bill-1.svg'),
            title: 'SRD 175.000',
            key: 'insuredAmount',
          },
          {
            id: 190000,
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/money-bill-1.svg'),
            title: 'SRD 190.000',
            key: 'insuredAmount',
          },
          {
            id: 220000,
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/money-bill-1.svg'),
            title: 'SRD 220.000',
            key: 'insuredAmount',
          },
          {
            id: 250000,
            // eslint-disable-next-line global-require
            icon: require('@/assets/svg/money-bill-1.svg'),
            title: 'SRD 250.000',
            key: 'insuredAmount',
          },
        ]
      }
      return [
        {
          id: 175000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 175.000',
          key: 'insuredAmount',
        },
        {
          id: 190000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 190.000',
          key: 'insuredAmount',
        },
        {
          id: 220000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 220.000',
          key: 'insuredAmount',
        },
        {
          id: 250000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 250.000',
          key: 'insuredAmount',
        },
        {
          id: 300000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 300.000',
          key: 'insuredAmount',
        },
        {
          id: 350000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 350.000',
          key: 'insuredAmount',
        },
        {
          id: 425000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 425.000',
          key: 'insuredAmount',
        },
        {
          id: 525000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 525.000',
          key: 'insuredAmount',
        },
        {
          id: 650000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 650.000',
          key: 'insuredAmount',
        },
        {
          id: 800000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 800.000',
          key: 'insuredAmount',
        },
        {
          id: 1000000,
          // eslint-disable-next-line global-require
          icon: require('@/assets/svg/money-bill-1.svg'),
          title: 'SRD 1000.000',
          key: 'insuredAmount',
        },
      ]
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    resetForm() {
      this.calculation = JSON.parse(JSON.stringify(this.blankCalculation))
      this.$refs.insuranceType.reset()
      this.$refs.information.reset()
      this.$refs.offer.reset()
      this.$refs.refWizard.reset()
    },
    setPzsType(type) {
      this.calculation.pzsType = type
    },
    validationInsuranceTypeForm() {
      return new Promise((resolve, reject) => {
        this.$refs.insuranceType.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationInformationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.information.validate().then(success => {
          if (success) {
            // eslint-disable-next-line no-unused-vars
            let cat = this.calculation.category
            if (this.calculation.category.includes('FREIGHT')) {
              cat = 'FREIGHT'
            }
            if (this.calculation.category.includes('PRIVATE')) {
              cat = this.calculation.class
            }
            store.dispatch('app-wam/calculate', {
              constructionYear: this.calculation.constructionYear,
              category: cat,
              weight: this.calculation.weight,
              persons: this.calculation.persons,
              payload: this.calculation.payload,
              insuredAmount: this.calculation.insuredAmount,
              miniInsuredAmount: this.calculation.miniInsuredAmount,
              includeLegalInsurance: this.calculation.includeLegalInsurance,
              includeOccupantsInsurance: this.calculation.includeOccupantsInsurance,
            })
              .then(response => {
                this.calculation.miniAvailable = response.data.miniAvailable

                this.calculation.premium = new Intl.NumberFormat('nl-NL', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(response.data.premium)

                if (this.isFirstTime && response.data.miniAvailable) {
                  this.isFirstTime = false
                  reject()
                } else {
                  resolve(true)
                }
              })
              .catch(() => {
                reject()
              })
          } else {
            reject()
          }
        })
      })
    },
    formSubmitted() {
      this.$refs.offer.validate().then(success => {
        if (success) {
          this.calculation.emailText = `
          <h3>Motorrijtuigenverzekering</h3>
          Voertuigtype: ${this.calculation.category ? this.categoryButtons.filter(f => String(f.id) === String(this.calculation.category))[0].title : ''}<br/>
          Gebruiksvorm: ${this.calculation.class ? this.classButtons.filter(f => String(f.id) === String(this.calculation.class))[0].title : ''}<br/>
          Gewicht (kg): ${this.calculation.weight ? this.calculation.weight : ''}<br/>
          Aantal zitplaatsen: ${this.calculation.persons ? this.personsOptions.filter(f => String(f.value) === String(this.calculation.persons))[0].title : ''}<br/>
          Laadvermogen (kg): ${this.calculation.payload ? this.payloadOptions.filter(f => String(f.value) === String(this.calculation.payload))[0].title : ''}<br/>
          Gewenste dekking: ${this.calculation.insuredAmount ? this.insuredAmountButtons.filter(f => String(f.id) === String(this.calculation.insuredAmount))[0].title : ''}<br/>
          Dekking: ${this.calculation.insuredAmount ? this.calculation.insuredAmount : ''}<br/>
          Bouwjaar: ${this.calculation.constructionYear ? this.calculation.constructionYear : ''}<br/>
          Mini casco dekking: ${this.calculation.miniInsuredAmount ? this.calculation.miniInsuredAmount : ''}<br/>
          MSR en mini casco Gewenste dekking: ${this.calculation.miniInsuredAmount ? this.miniCascoButtons.filter(f => String(f.id) === String(this.calculation.miniInsuredAmount))[0].title : ''}<br/>
          Rechtsbijstand: ${this.calculation.constructionYear ? this.calculation.constructionYear : ''}<br/>
          Ongevallen inzittenden verzekering: ${this.calculation.includeOccupantsInsurance ? String(this.calculation.includeOccupantsInsurance) : ''}<br/>
          Ongevallen inzittenden verzekering: ${this.calculation.includeOccupantsInsurance ? String(this.calculation.includeOccupantsInsurance) : ''}<br/>
          Premie indicatie: ${this.calculation.includeLegalInsurance ? String(this.calculation.includeLegalInsurance) : ''}
          `
          store.dispatch('app-wam/sendOfferMail', this.calculation)
            .then(() => {
              this.$swal({
                icon: 'success',
                title: 'Offerte aanvraag!',
                text: 'Bedankt voor uw offerte aanvraag, wij zullen spoedig contact met u opnemen.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              }).then(() => {
                this.resetForm()
              })
            })
            .catch(() => {
              this.$swal({
                icon: 'error',
                title: 'Relatie!',
                text: 'Er is een fout opgetreden bij het verwerken van uw offerte aanvraag. Probeer het later nog een keer.',
                customClass: {
                  confirmButton: 'btn btn-danger',
                },
              })
            })
        }
      })
    },
  },
  setup() {
    const WAM_MODULE_NAME = 'app-wam'

    // Register module
    if (!store.hasModule(WAM_MODULE_NAME)) store.registerModule(WAM_MODULE_NAME, wamStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(WAM_MODULE_NAME)) store.unregisterModule(WAM_MODULE_NAME)
    })

    const {
      refFormObserver,
      getValidationState,
    } = formValidation(() => {
    })

    return {
      refFormObserver,
      getValidationState,
      required,
      countryList,
      surinameCityList,
      districtsList,
      formatPrice,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
.v-radio-label {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  margin: 5px;
  border-radius: 4px;
  //border: 1px solid #eee;
  transition: all 500ms;
  background: rgba(253, 184, 19, 0.12);
  color: #000000;
  font-weight: bold;
  font-size: 12px;
}

.v-radio-active {
  //border: 2px solid #ce2a56;
  background-color: rgba(253, 184, 19, 0.4);
  //box-shadow: 0 1px 5px 0 rgba(206, 42, 86,.12); // #ce2a56 //#f3f2ee
  color: #000000;
  //img {
  //  filter: invert(100%) sepia(53%) saturate(1530%) hue-rotate(290deg) brightness(118%) contrast(102%);
  //}
}
</style>
